export default {
  forms: [],
  questions: [],
  consentFormInfo: {},
  isSubmitting: false,
  submissionCompleted: false,
};
